import React from 'react';

import l10n from "../../../l10n/localization";

import { Table } from "react-materialize";
import Loader from "../../common/Loader";
import * as contactActions from "../../../actions/clientContact";
import {connect} from "react-redux";
import ContactItem from "./ContactItem";

class ContactTable extends React.Component {

    componentDidMount() {
        this.props.dispatch(contactActions.fetchContacts(this.props.client.id, true));
    }

    render() {
        if (this.props.loading || this.props.contacts === undefined) {
            return (<div><Loader /></div>)
        }

        return (
            <Table bordered>
                <thead>
                <tr>
                    <th data-field="mainContact">Main</th>
                    <th data-field="name">{l10n.contact.name}</th>
                    <th data-field="email">{l10n.contact.email}</th>
                    <th data-field="actions">{l10n.client.actions}</th>
                </tr>
                </thead>

                <tbody>
                {this.props.contacts.map((item, index) => (
                    <ContactItem {...this.props} item={item} client={this.props.client} openDrawer={this.props.openDrawer} key={index} depth={this.props.depth + 1}/>
                ))}
                </tbody>
            </Table>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        contacts: state.clientContact.contacts,
        loading: state.clientContact.loading,
        deletingClientcontact: state.clientContact.deleting
    });
})(ContactTable);



// WEBPACK FOOTER //
// ./src/components/client/contact/ContactTable.js